import React, { useState, useEffect } from "react";
import {
  Typography,
  Button,
  Stepper,
  Step,
  StepLabel,
} from "@material-ui/core";
import Checkbox from "@mui/material/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import InputField from "../common/InputField";
import GlobalDropDown from "../common/GlobalDropDown";
import { Country, State, City } from "country-state-city";
import FormValidator from "./FormValidator";
import SubmitForm from "../CohortForms/SubmitForm";

import "./styles.scss";
import MultiselectorComp from "../MultiselectorComp/MultiselectorComp.js";
// import { components } from "react-select";
import Select, { components, DropdownIndicatorProps } from "react-select";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
// import update from 'immutability-helper';
import { registerMentor } from "./dependencies/action";
import { useHistory, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Modal from "../../components/common/Modal";

const useStyles = makeStyles((theme) => ({
  button: {
    leftbutton: {
      marginRight: theme.spacing(1),
      backgroundColor: "#3AC2D7",
      color: "#fff",
      width: "150px",
    },
    rightbutton: {
      marginRight: "8px",
      backgroundColor: "#f4f4f4",
      border: "1 solid #000",
      width: "150px",
    },
  },
}));

const customStyles = {
  option: (provided, state) => ({
    ...provided,

    textAlign: "left",
  }),
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize:"14px"
}),
};

const MentorFillupFormD = (props) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [skippedSteps, setSkippedSteps] = useState([]);
  const [showSubmitCohort, setShowSubmitCohort] = useState(false);
  const [submitFormData, setSubmitFormData] = useState({});
  const [loginData, setLoginData] = useState();

  const { mentorFormList = {} } = props;
  const { list = [] } = mentorFormList;
  const copyList = cloneDeep(list);
  const [listData, setListData] = useState(copyList);
  const history = useHistory();

  useEffect(() => {
    setListData(cloneDeep(list));
  }, [list]);
  var formData = {};
  const testFunction = () => {
    listData.forEach((stepName) => {
      var fieldList = stepName.fieldList;

      if (Array.isArray(fieldList)) {
        fieldList.forEach((list) => {
          formData[list.id] = list.value;
        });
      }
    });

    return formData;
  };

  

  function getSteps() {
    return list?.map((step) => step.stepName);
  }

  const clickOnClose = () => {
    setShowSubmitCohort((x) => !x);
    // getActivityFellow()
  };

  const onBlur = () => {
    
  };

  const handleInputChange = (id, value, step) => {
    
    let newData = get(listData, step, {});
    let data = newData.fieldList.find((o) => o.id === id);
    let dataIndex = newData.fieldList.findIndex((o) => o.id === id);
    

    const newObj = {
      ...data,
      value: value,
    };

    // const newFormdata=
    // update(listData,{
    //   [step]: page => update(page,{
    //     fieldList: fieldList => update(fieldList,{
    //       [dataIndex]: element => update(element,{
    //         $set: newObj
    //       })
    //     })
    //   }
    //   )
    // })
    // setListData(newFormdata)
  };

  const getCurrentOject = get(listData, activeStep, []);
  
  function getStepContent(step) {
    let currentOjectType = "";
    if (getCurrentOject) {
      return (currentOjectType = getCurrentOject?.fieldList?.map(
        (fieldList, index) => {
          if (
            fieldList.type === "textfield" ||
            fieldList.type === "email" ||
            fieldList.type === "number" ||
            fieldList.type === "url" ||
            fieldList.type === "textarea"
          ) {
            return (
              <>
                <div
                  className="mentorformsteps row"
                  style={{ paddingBottom: "10px" }}
                >
                  <InputField
                    key={index}
                    required={fieldList.required}
                    id={fieldList.id}
                    label={fieldList.label}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    onChange={(e) =>
                      handleInputChange(fieldList.id, e.target.value, step)
                    }
                    value={fieldList.value}
                    name={fieldList.id}
                    onBlur={onBlur}
                  />
                </div>
              </>
            );
          } else if (fieldList.type === "select") {
            const selectOption = Object.keys(fieldList.option);

            return (
              <div
                className="mentorformsteps row"
                style={{ paddingBottom: "10px" }}
              >
                <span
                  class="d-inline-block multiselectorspan"
                  data-toggle="popover"
                  data-trigger="focus"
                  data-content="Please selecet account(s)"
                >
                  <MultiselectorComp
                    key={index}
                    required={fieldList.required}
                    id={fieldList.id}
                    label={fieldList.label}
                    options={fieldList.option}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    placeholder={fieldList.label}
                    styles={customStyles} //setIndustry(v)
                    onChange={(e) => handleInputChange(fieldList.id, e, step)}
                    value={fieldList.value}
                    onBlur={onBlur}
                  />
                </span>
              </div>
            );
          } else if (fieldList.type === "webform_document_file") {
            return (
              <div
                className="mentorformsteps row"
                style={{ paddingBottom: "10px" }}
              >
                <div className="file_upload">
                  <div>
                    <p className="upload-mentor-text">
                      {fieldList.label}
                      <span>
                        Supported file format jpeg, png only upto 500KB
                      </span>
                    </p>

                    <input
                      key={index}
                      type="file"
                      // name="Upload Document"
                      id={fieldList.id}
                      name="uploadProfilePic"
                      //accept="image/*"
                      accept="application/pdf, application/vnd.ms-excel"
                      onChange={(e) =>
                        handleInputChange(fieldList.id, e.target.files[0], step)
                      }
                      onBlur={onBlur}
                      // onchange="document.getElementById('blah').src = window.URL.createObjectURL(this.files[0])"
                    />
                  </div>
                </div>
              </div>
            );
          } else if (fieldList.type === "webform_image_file") {
            return (
              <div
                className="mentorformsteps row"
                style={{ paddingBottom: "10px" }}
              >
                <div className="file_upload">
                  <div>
                    <p className="upload-mentor-text">
                      {fieldList.label}
                      <span>
                        Supported file format jpeg, png only upto 500KB
                      </span>
                    </p>

                    <input
                      key={index}
                      type="file"
                      // name="Upload Document"
                      id={fieldList.id}
                      name="uploadProfilePic"
                      accept="image/*"
                      // accept="application/pdf, application/vnd.ms-excel"
                      onChange={(e) =>
                        handleInputChange(fieldList.id, e.target.files[0], step)
                      }
                      onBlur={onBlur}
                      // onchange="document.getElementById('blah').src = window.URL.createObjectURL(this.files[0])"
                    />
                  </div>
                </div>
              </div>
            );
          } else if (fieldList.type === "checkbox") {
            return (
              <div className="mentorformsteps row">
                <div className="disclaimerMaindiv">
                  <Checkbox
                    key={index}
                    checked={fieldList.value}
                    onClick={(e) =>
                      handleInputChange(fieldList.id, e.target.checked, step)
                    }
                    sx={{
                      color: "#F78F54",
                      "&.Mui-checked": {
                        color: "#F78F54",
                      },
                    }}
                  />
                  <div className="actualdisclaimer">
                    {fieldList.description}
                  </div>
                </div>
              </div>
            );
          } else {
            return "";
          }
          //return fieldList
        }
      ));
    } else {
    }
  }

  const steps = getSteps();
  const allStepsData = steps.map((step, index) => {
    return (
      <li
        className={
          activeStep === index
            ? "active"
            : index <= activeStep
            ? "active"
            : "lastStep"
        }
        key={index}
      >
        <span className="count">
          <span>{index + 1}</span>
        </span>
        <div className="text">
          <p>{step}</p>
        </div>
      </li>
    );
  });

  const isStepSkipped = (step) => {
    return skippedSteps.includes(step);
  };

  const handleNext = (submitData) => {
    const { registerMentor } = props;
    
    if (submitData) {
      
      registerMentor(formData).then((res) => {
        
        if (res) {
          if (res) {
            history.push({
              pathname: "/",
            });

            // onCloseBothModal();
            //onClose();
            //
          }
        } else {
          history.push({
            pathname: "/become-a-mentor",
          });
        }
      });
    }
    setActiveStep(activeStep + 1);
    setSkippedSteps(skippedSteps.filter((skipItem) => skipItem !== activeStep));
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <div>
      <Stepper alternativeLabel activeStep={activeStep}>
        {
          <Step>
            <div className="row steps-mentor">
              <div className="col-12">
                <ul>{allStepsData}</ul>
              </div>
            </div>
          </Step>
        }
      </Stepper>

      {activeStep === steps.length ? (
        <Typography variant="h3" align="center">
          Thank You
        </Typography>
      ) : (
        <>
          <form>{getStepContent(activeStep)}</form>

          {activeStep === 0 ? (
            ""
          ) : (
            <Button
              style={{
                color: "#3AC2D7",
                marginRight: "8px",
                backgroundColor: "#f4f4f4",
                width: "150px",
                border: "1px solid #00000040",
                marginTop: "20px",
              }}
              // className={classes.button}
              // variant="outlined"

              disabled={activeStep === 0}
              color="primary"
              onClick={handleBack}
            >
              {/* &#8592; */}
              <i className="fa fa-arrow-left"></i> &nbsp;
              {activeStep === 0 ? "Cancel" : "previous"}
            </Button>
          )}

          <Button
            //  type="submit"
            className={classes.button}
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#3AC2D7",
              color: "#fff",
              width: "150px",
              marginTop: "20px",
            }}
            onClick={(e) =>
              handleNext(steps.length && activeStep === steps.length - 1)
            }
          >
            {steps.length && activeStep === steps.length - 1
              ? "Submit"
              : "Next"}{" "}
            &nbsp;
            <i className="fa fa-arrow-right"></i>
          </Button>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps, {
  registerMentor,
})(withRouter(MentorFillupFormD));
